import gsap from 'gsap';
import slideDownFade from './slideDownFade';
import slideUpFade from './slideUpFade';
export default function slideFadeToggle(target) {
  var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (gsap.getProperty(target, 'display') === 'none') {
    return slideDownFade(target, duration, options);
  }

  return slideUpFade(target, duration, options);
}